module.exports = __webpack_public_path__ + "e374fe451764e7644b5531feb5fc10c0.svg";